import { FileArrowUpDownIcon } from './FileArrowUpDownIcon';

/**
 * author: Colton Wiscombe
 * id 8D429186-1CB7-4DC1-AD90-43F2F41AF424
 * name file-arrow-up-down
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-arrow-up-down.svg
 * tags
 * - Files / Folders 
 */
export const FileUploadDownloadIcon = FileArrowUpDownIcon;
export default FileUploadDownloadIcon